/* eslint-disable */
import React, {useState} from 'react';
import LineChart from '../../component/Inc/LineChart';
import Tab from '../../component/Inc/Tab';
import Paging from '../../component/Inc/Paging';
import Calendar from '../../component/Inc/Calendar';
import Modal from '../../component/Inc/Modal';
import PopRecommend from './_PopRecommend';
import 'contents/assets/scss/page/main.scss';
function MonthlyBestTeacherManage() {
  const [isOrderActive1, setIsOrderActive1] = useState(false);
  const [tabIdx, setTabIdx] = useState(0);
  const [modalRecommend, setModalRecommend] = useState(false);
  const [modalConfirm, setModalConfirm] = useState(false);
  const listItems = ['2024-05-12 ㅣ  최길동305', '2024-05-12 ㅣ  최길동305', '2024-05-12 ㅣ  최길동305', '2024-05-12 ㅣ  최길동305', '2024-05-12 ㅣ  최길동305', '2024-05-12 ㅣ  최길동305', '2024-05-12 ㅣ  최길동305'];
  const [selectedItem, setSelectedItem] = useState(null);
  const tab = [
    {title: '전체', value: 0},
    {title: '우선 선정', value: 1},
    {title: '추천 선정', value: 2}
  ];
  const lineChartWidth = '100%';
  const lineChartHeight = '147px';
  const yearlabels = ['2019', '2020', '2021', '2022', '2023', '2024'];
  const timelabels = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];

  const dataTime = {
    lineChartlabels: yearlabels,
    datasets: [
      {
        label: '2022',
        data: [20000, 40000, 20000, 50000, 20000, 30000, 10000, 20000, 40000, 20000, 50000, 20000, 30000, 1000],
        backgroundColor: '#3780ff',
        borderColor: '#d1cdca',
        borderWidth: 1,
        fill: false
      }
    ]
  };
  //인계
  const dataTime2 = {
    lineChartlabels: timelabels,
    datasets: [
      {
        label: '2023',
        data: [10000, 20000, 40000, 20000, 50000, 20000, 30000, 10000, 20000, 40000, 20000, 50000, 20000, 30000],
        backgroundColor: '#fc8019',
        borderColor: '#d1cdca',
        borderWidth: 1,
        fill: false
      }
    ]
  };

  return (
    <main className="com_container p_monthly_manage">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu0_2  active">
            이달의 우수교사 <span className="bar"></span>
            <span className="point_txt">우수교사 관리</span>
          </h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalRecommend(true)} className="com_btn orange s btn_plus">
              우수 교사 추천
            </button>
          </div>
        </section>
        <section className="com_pg_container">
          <div className="box">
            <div className="com_board_list__top">
              <Calendar />
            </div>
            <div className="com_board_list__top">
              <Tab data={tab} tab={tabIdx} tabStyle="gray" setTab={setTabIdx} />
              <article className="search">
                <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                <button className="com_btn gray ws s icon_search"></button>
              </article>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="60" />
                <col width="100" />
                <col width="100" />
                <col width="100" />
                <col width="110" />
                <col width="110" />
                <col width="90" />
                <col width="120" />
              </colgroup>
              <thead>
                <tr>
                  <th>NO</th>
                  <th>교사명</th>
                  <th>소속 / 과목</th>
                  <th>
                    이번달 타임&nbsp;
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                  </th>
                  <th>
                    작년 총 타임&nbsp;
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                  </th>
                  <th>
                    금년 평균 타임&nbsp;
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                  </th>
                  <th>
                    추천수&nbsp;
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                  </th>
                  <th>
                    우수교사 선택 수&nbsp;
                    <button
                      onClick={() => {
                        setIsOrderActive1(!isOrderActive1);
                      }}
                      className={`arrow ${isOrderActive1 ? `active` : ``}`}
                    />
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr className="selected">
                  <td>1</td>
                  <td>김교사123</td>
                  <td>본사 / 영어</td>
                  <td>12</td>
                  <td>456</td>
                  <td>123</td>
                  <td>8</td>
                  <td>8</td>
                </tr>
                {[...Array(9)].map((_, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>김교사123</td>
                    <td>본사 / 영어</td>
                    <td>12</td>
                    <td className="td_point">456</td>
                    <td>123</td>
                    <td>8</td>
                    <td>8</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <Paging />
          </div>
          {/* 상세보기 */}
          <div className="box">
            <div className="detail_tit dot">상세보기</div>
            <div className="com_info">
              <p className="name">홍길동104</p>
              <span className="dot"></span>
              <p className="date">2023.05.20 11:30</p>
            </div>

            <table className="com_board_list">
              <colgroup>
                <col width="33.33%" />
                <col width="33.33%" />
                <col width="33.33%" />
              </colgroup>
              <thead>
                <tr>
                  <th>이번달 타임</th>
                  <th>작년 총 타임</th>
                  <th>금년 평균 타임</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>12</td>
                  <td>456</td>
                  <td>123</td>
                </tr>
              </tbody>
            </table>
            <div className="com_chart_wrap">
              <div className="chart_body">
                <div className="chart_name">연간 평균 지수</div>
                <div className="chart_content">
                  <LineChart data={dataTime} width={lineChartWidth} height={lineChartHeight} />
                </div>
              </div>
            </div>
            <div className="com_chart_wrap">
              <div className="chart_body">
                <div className="chart_name">월간 평균 지수</div>
                <div className="chart_content">
                  <LineChart data={dataTime2} width={lineChartWidth} height={lineChartHeight} />
                </div>
              </div>
            </div>
            <div className="detail_tit_sub">
              <span className="name">추천 (45)</span>
            </div>
            <div className="com_scroll_list_wrap">
              <ul className="com_scroll_list pick">
                {listItems.map((item, index) => (
                  <li key={index} className={`item ${selectedItem === index ? 'selected' : ''}`} onClick={() => setSelectedItem(index)}>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="detail_tit_sub">
              <span className="name">우수교사 선택 수 (12)</span>
            </div>
            <div className="selected_teacher_wrap">
              <ul className="list">
                <li>2024-05 ㅣ 추천선정 ㅣ 24인센 ㅣ 성실하고 착합니다.</li>
                <li>2024-05 ㅣ 추천선정 ㅣ 24인센 ㅣ 성실하고 착합니다.</li>
              </ul>
            </div>
            <div className="com_board_box">
              <table className="com_board_list type_row">
                <colgroup>
                  <col width="140" />
                  <col width="auto" />
                </colgroup>
                <tbody>
                  <tr>
                    <th>우수 월 선택</th>
                    <td>
                      <div className="com_calendar_wrap">
                        <div className="year ">
                          <button className="btn btn_prev_gray"></button>
                          <button className="btn_txt">
                            12<span className="sub">월</span>
                          </button>
                          <button className="btn btn_next_gray"></button>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>선정방법</th>
                    <td>
                      <div className="check">
                        <input type="radio" name="rdo" id="rdo01" className="com_chk circle" />
                        <label htmlFor="rdo01">추천선정</label>
                        <input type="radio" name="rdo" id="rdo02" className="com_chk circle" />
                        <label htmlFor="rdo02">우선선정</label>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th>포인트</th>
                    <td>
                      <input type="text" className="input" placeholder="입력" />
                    </td>
                  </tr>
                  <tr>
                    <th>사유 내용</th>
                    <td>
                      <input type="text" className="input" placeholder="입력" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="com_btn_wrap center bottom">
              <button onClick={() => setModalConfirm(true)} className="com_btn orange s">
                등록
              </button>
            </div>
          </div>
        </section>
      </div>
      <PopRecommend open={modalRecommend} close={() => setModalRecommend(false)} />

      <Modal open={modalConfirm} close={() => setModalConfirm(false)} type="type_alert">
        <h2 className="pop_tit">알 림</h2>
        <div className="content_container mb_no">
          <div className="txt">
            등록된 내용이 당월에 도래했을 경우
            <br /> 삭제, 수정이 불가능 합니다. <br /> 등록 하시겠습니까?
          </div>
        </div>
        <div className="btn_container">
          <button className="com_btn lightGray xs">취소</button>
          <button className="com_btn orange xs">확인</button>
        </div>
      </Modal>
    </main>
  );
}

export default MonthlyBestTeacherManage;
